const disbursementRequestType = Object.freeze({
  UnSet: 0,
  Refund: 1,
  DirectPayment: 2,
});

export default disbursementRequestType;
